const isObjectEmpty = (obj: object): boolean => {
  return (
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
};
export default isObjectEmpty;
